<template>
    <span class="order" @click="change" :class="cOrder">
        <svg><use xlink:href="#icon-arrow"></use></svg>
        <svg><use xlink:href="#icon-arrow"></use></svg>
    </span>
</template>

<script>
    import tools from '../config.ts';
    export default {
        name: "TableOrder",
        props : {
            order:"",
            name:"",
        },
        data(){
            return {
                cOrder:''
            }
        },
        methods:{
            change(){
                switch(this.cOrder){
                    case '' : this.cOrder = 'asc'; break;
                    case 'asc' : this.cOrder = 'desc'; break;
                    case 'desc' : this.cOrder = 'asc'; break;
                }
                this.$emit("change",{
                    order:this.cOrder,
                    name:this.name
                });
                tools.$emit("orderChange",{
                    order:this.cOrder,
                    name:this.name
                });
            },
            show(order){
                if(this.cOrder === ''){
                    return true;
                }

                return this.cOrder === order;
            }
        },
        watch:{
            order(){
                this.cOrder = this.order || '';
            }
        },
        mounted(){
            this.cOrder = this.order || '';

            tools.$on("orderChange",(data) => {
                if(this.name !== data.name){
                    this.cOrder = '';
                    return;
                }

                this.cOrder = data.order;
            });
        }
    }
</script>